class MegaMenuHover {
  constructor() {
    this.megaMenus = document.querySelectorAll('.mega-menu');
    this.isDesktop = window.innerWidth >= 990;
    this.init();
  }

  init() {
    if (this.isDesktop) {
      this.setupDesktopHover();
    }
    
    // Listen for window resize to switch between hover and click modes
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  setupDesktopHover() {
    this.megaMenus.forEach(menu => {
      const summary = menu.querySelector('summary');
      const content = menu.querySelector('.mega-menu__content');
      
      if (!summary || !content) return;

      let closeTimeout;

      // Mouse enter - open menu immediately
      menu.addEventListener('mouseenter', () => {
        clearTimeout(closeTimeout);
        this.openMenu(menu, summary, content);
      });

      // Mouse leave - close menu with delay
      menu.addEventListener('mouseleave', () => {
        closeTimeout = setTimeout(() => {
          this.closeMenu(menu, summary, content);
        }, 150); // 150ms delay to prevent accidental closing
      });

      // Prevent menu from closing when moving from summary to content
      content.addEventListener('mouseenter', () => {
        clearTimeout(closeTimeout);
        this.openMenu(menu, summary, content);
      });

      // Handle keyboard navigation
      summary.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          // Check if the summary has a URL (parent menu item with link)
          const summaryLink = summary.querySelector('a');
          if (summaryLink && summaryLink.href) {
            // Allow navigation to the parent menu item
            window.location.href = summaryLink.href;
            return;
          }
          
          // Otherwise, toggle the dropdown menu
          e.preventDefault();
          if (menu.hasAttribute('open')) {
            this.closeMenu(menu, summary, content);
          } else {
            this.openMenu(menu, summary, content);
          }
        }
      });

      // Handle click navigation for parent menu items with URLs
      summary.addEventListener('click', (e) => {
        const summaryLink = summary.querySelector('a');
        if (summaryLink && summaryLink.href) {
          // Prevent the default summary behavior and navigate to the link
          e.preventDefault();
          e.stopPropagation();
          window.location.href = summaryLink.href;
        }
      });

      // Close menu when clicking outside
      document.addEventListener('click', (e) => {
        if (!menu.contains(e.target)) {
          this.closeMenu(menu, summary, content);
        }
      });
    });
  }

  openMenu(menu, summary, content) {
    if (!this.isDesktop) return;
    
    menu.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
    
    // Trigger animation
    if (content.getAnimations) {
      const animations = content.getAnimations();
      animations.forEach(animation => animation.play());
    }
  }

  closeMenu(menu, summary, content) {
    if (!this.isDesktop) return;
    
    menu.removeAttribute('open');
    summary.setAttribute('aria-expanded', 'false');
    
    // Trigger animation
    if (content.getAnimations) {
      const animations = content.getAnimations();
      animations.forEach(animation => animation.cancel());
    }
  }

  handleResize() {
    const wasDesktop = this.isDesktop;
    this.isDesktop = window.innerWidth >= 990;
    
    // If switching between desktop and mobile, reinitialize
    if (wasDesktop !== this.isDesktop) {
      this.cleanup();
      this.init();
    }
  }

  cleanup() {
    // Remove event listeners if needed
    this.megaMenus.forEach(menu => {
      if (menu && menu.parentNode) {
        const newMenu = menu.cloneNode(true);
        menu.parentNode.replaceChild(newMenu, menu);
      }
    });
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new MegaMenuHover();
});

// Also initialize if script is loaded after DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MegaMenuHover();
  });
} else {
  new MegaMenuHover();
} 